module.exports = __webpack_public_path__ + "img/the-factory-bloc-album.8b6a58a2.jpg";